/**
 * 温湿度动态图表 — POST /api/produce/kanban/temperature-humidity-dynamic-chart
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/temperature-humidity-dynamic-chart'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchTemperatureHumidityChart(data = {}) {
  return request({
    url: API,
    method: 'post',
    data
  }).then(unwrap)
}
